/**
 * container for sensitive information,
 * when the user does not have the rights to view this information error number will be > 0
 *
 * rbac privilege: ACCESS_SENSITIVE_DATA
 * @see GeneralPrivilegeType
 * no error: 0
 */
export interface Sensitive<T> {
    sensitiveData: T
    error: number
}

/**
 * creator function for sensitive data
 */
export function makeSensitive<T>( data: T, error: number = 0 ): Sensitive<T> {
    return {
        sensitiveData: data,
        error: error
    };
}

